import { useMutation } from "@/api/utils/useQuery"
import { MutationResult } from "@/api/utils/types"
import {
  BackofficeRestMutations,
  SubmitSmartPayAsYouGoPayload,
} from "@/api/backofficeRest/mutations"

export interface ISmartPayAsYouGoMutator {
  submit(): MutationResult<SubmitSmartPayAsYouGoPayload, void>
}

class SmartPayAsYouGoMutatorClass implements ISmartPayAsYouGoMutator {
  submit(): MutationResult<SubmitSmartPayAsYouGoPayload, void> {
    return useMutation({
      ...BackofficeRestMutations.smartPayAsYouGo.submit(),
      serializerFn: (data: SubmitSmartPayAsYouGoPayload) => data,
      invalidateCache: false,
    })
  }
}

export const SmartPayAsYouGoMutator = new SmartPayAsYouGoMutatorClass()
